import { render } from "./HiFireNewDocDialog.vue?vue&type=template&id=570b79ca"
import script from "./HiFireNewDocDialog.vue?vue&type=script&lang=js"
export * from "./HiFireNewDocDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__